var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_311_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 30.3604C27.2367 30.3604 29.8606 27.7365 29.8606 24.4998C29.8606 21.263 27.2367 18.6392 24 18.6392C20.7633 18.6392 18.1394 21.263 18.1394 24.4998C18.1394 27.7365 20.7633 30.3604 24 30.3604Z",
    stroke: "#27C3E2",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9706 19.7089H38.3439C38.1209 19.0398 37.8483 18.3832 37.5303 17.743L39.3888 15.8844C39.9918 15.2814 39.9918 14.2985 39.3888 13.6955L34.8044 9.11108C34.2014 8.50809 33.2184 8.50809 32.6155 9.11108L30.7569 10.9696C30.1167 10.6516 29.4601 10.379 28.791 10.156V7.52926C28.791 6.67433 28.0971 5.98047 27.2422 5.98047H20.7579C19.903 5.98047 19.2092 6.67433 19.2092 7.52926V10.156C18.5401 10.379 17.8834 10.6516 17.2432 10.9696L15.3847 9.11108C14.7817 8.50809 13.7987 8.50809 13.1957 9.11108L8.61133 13.6955C8.00833 14.2985 8.00833 15.2814 8.61133 15.8844L10.4699 17.743C10.1519 18.3832 9.87927 19.0398 9.65624 19.7089H7.0295C6.17457 19.7089 5.48071 20.4028 5.48071 21.2577V27.742C5.48071 28.5969 6.17457 29.2907 7.0295 29.2907H9.65624C9.87927 29.9598 10.1519 30.6165 10.4699 31.2567L8.61133 33.1152C8.00833 33.7182 8.00833 34.7012 8.61133 35.3042L13.1957 39.8886C13.7987 40.4916 14.7817 40.4916 15.3847 39.8886L17.2432 38.03C17.8834 38.348 18.5401 38.6206 19.2092 38.8437V41.4704C19.2092 42.3253 19.903 43.0192 20.7579 43.0192H27.2422C28.0971 43.0192 28.791 42.3253 28.791 41.4704V38.8437C29.4601 38.6206 30.1167 38.348 30.7569 38.03L32.6155 39.8886C33.2184 40.4916 34.2014 40.4916 34.8044 39.8886L39.3888 35.3042C39.9918 34.7012 39.9918 33.7182 39.3888 33.1152L37.5303 31.2567C37.8483 30.6165 38.1209 29.9598 38.3439 29.2907H40.9706C41.8256 29.2907 42.5194 28.5969 42.5194 27.742V21.2577C42.5194 20.4028 41.8256 19.7089 40.9706 19.7089Z",
    stroke: "#276AE2",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_311_3013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/SettingIcon.50ec5f5992d10f0d4c3105b5b8ea9de5.svg";
export { ForwardRef as ReactComponent };